module.exports = __webpack_public_path__ + "static/img/05_アルコール@2x.d3e5550.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/05_アルコール@2x.png
// module id = 6GC/
// module chunks = 0